import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import AlertWindow from '../components/Alert'

function ViewBooking({ viewBookingToggle, setViewBookingToggle }) {
  const navigate = useNavigate();
  const [openAlert, setOpenAlert] = useState(false)
  const alertMessage = useState('Please filled in all information')

  const closeEvent = () => {
    setViewBookingToggle(false)
  }

  const [viewBookingData, setViewBookingData] = useState({
    orderID: '',
    lastname: '',
  })

  const handleChange = (event, key) => {
    setViewBookingData(prevState => ({
      ...prevState,
      [key]: event.target.value
    }));
  }

  const checkOrderID = async () => {
    if (viewBookingData.orderID !== '' && viewBookingData.lastname !== '') {
      navigate("/viewbooking/" + viewBookingData.orderID + '/' + viewBookingData.lastname)
      closeEvent()
    } else {
      setOpenAlert(true)
    }
  }

  return (
    <div>
      {viewBookingToggle && <div id="default-modal" tabindex="-1" aria-hidden="true" class="fixed inset-0 z-20 flex justify-center items-center bg-gray-500 bg-opacity-50">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
          <div class="relative bg-white rounded-lg shadow-sm">
            <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t border-gray-200">
              <h3 class="text-xl font-semibold text-gray-900">
                View my booking
              </h3>
              <button type="button" onClick={closeEvent} class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="default-modal">
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
            </div>
            <div class="p-4 md:p-5 space-y-4">
              <div class="flex flex-col">
                <label for="orderid" class="text-sm font-medium text-gray-600 text-start">Order ID <span class="text-red-500">*</span></label>
                <input value={viewBookingData.orderID} onChange={(event) => handleChange(event, 'orderID')} type="text" id="orderid" placeholder="e.g. dl-..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2 " />
              </div>
              <div class="flex flex-col">
                <label for="lastName" class="text-sm font-medium text-gray-600 text-start">Last Name <span class="text-red-500">*</span></label>
                <input value={viewBookingData.lastname} onChange={(event) => handleChange(event, 'lastname')} type="text" id="lastName" placeholder="e.g. Li..." class="mt-1 p-3 border border-gray-300 rounded-lg text-sm text-gray-600 placeholder-gray-400 focus:ring-2" />
              </div>
            </div>
            <div class="flex items-center p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600" onClick={checkOrderID}>
              <button data-modal-hide="default-modal" type="button" class="text-white bg-primary focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center">View Now</button>
            </div>
          </div>
        </div>
        <AlertWindow setOpenAlert={setOpenAlert} openAlert={openAlert} message={alertMessage} />
      </div>
      }
    </div>
  );
}

export default ViewBooking;